module.exports = __webpack_public_path__ + "7645f5de3bc7165f231bb519c9aced8b.pdf";